import styled from 'styled-components';
import type { ColumnData } from 'ui/tableHeader/constants';
import { TableRows } from 'ui/tableRows';
import { TableHeader } from 'ui/tableHeader';
import { body2, spacing } from 'ui/theme';
import { Table } from 'ui/table';
import { ASCENDING } from 'constants/sortDirections';
import noop from 'utils/noop';

type RowContent = {
  row: {
    email: string;
    userId: string;
    firstName: string;
    lastName: string;
    someDate: Date;
    isFoobar: boolean;
  };
};

export const Cell = styled.div`
  ${body2};
  box-sizing: border-box;
  display: table-cell;
  overflow-y: visible;
  padding: ${spacing.threeQuarter};
  margin: 0;
`;

export const ExampleUserList = () => {
  return (
    <div>
      <Table>
        <TableHeader
          columns={[
            {
              name: 'Email (required)',
              value: 'email',
              align: 'flex-start',
              sortable: false,
              RowCell: ({ row }: RowContent) => <Cell>{row.email}</Cell>,
            } as ColumnData,
            {
              name: 'User ID',
              value: 'userId',
              align: 'flex-start',
              sortable: false,
              RowCell: ({ row }: RowContent) => <Cell>{row.userId}</Cell>,
            } as ColumnData,
            {
              name: 'First Name',
              value: 'firstName',
              align: 'flex-start',
              sortable: false,
              RowCell: ({ row }: RowContent) => <Cell>{row.firstName}</Cell>,
            } as ColumnData,
            {
              name: 'Last Name',
              value: 'lastName',
              align: 'flex-start',
              sortable: false,
              RowCell: ({ row }: RowContent) => <Cell>{row.lastName}</Cell>,
            } as ColumnData,
            {
              name: 'Some Date',
              value: 'someDate',
              align: 'flex-start',
              sortable: false,
              RowCell: ({ row }: RowContent) => (
                <Cell>
                  <>{row.someDate}</>
                </Cell>
              ),
            } as ColumnData,
            {
              name: 'IsFoobar',
              value: 'isFoobar',
              align: 'flex-start',
              sortable: false,
              RowCell: ({ row }: RowContent) => <Cell>{row.isFoobar}</Cell>,
            } as ColumnData,
          ]}
          setSortedBy={noop}
          setSortDirection={noop}
          sortedBy={''}
          sortDirection={ASCENDING}
        />
        <TableRows
          columns={[
            {
              name: 'Email',
              value: 'email',
              align: 'flex-start',
              sortable: false,
              RowCell: ({ row }: RowContent) => <Cell>{row.email}</Cell>,
            } as ColumnData,
            {
              name: 'UserId',
              value: 'userId',
              align: 'flex-start',
              sortable: false,
              RowCell: ({ row }: RowContent) => <Cell>{row.userId}</Cell>,
            } as ColumnData,
            {
              name: 'FirstName',
              value: 'firstName',
              align: 'flex-start',
              sortable: false,
              RowCell: ({ row }: RowContent) => <Cell>{row.firstName}</Cell>,
            } as ColumnData,
            {
              name: 'LastName',
              value: 'lastName',
              align: 'flex-start',
              sortable: false,
              RowCell: ({ row }: RowContent) => <Cell>{row.lastName}</Cell>,
            } as ColumnData,
            {
              name: 'SomeDate',
              value: 'someDate',
              align: 'flex-start',
              sortable: false,
              RowCell: ({ row }: RowContent) => (
                <Cell>
                  <>{row.someDate}</>
                </Cell>
              ),
            } as ColumnData,
            {
              name: 'IsFoobar',
              value: 'isFoobar',
              align: 'flex-start',
              sortable: false,
              RowCell: ({ row }: RowContent) => <Cell>{row.isFoobar}</Cell>,
            } as ColumnData,
          ]}
          rows={[
            {
              id: 'ExampleUser1',
              email: 'john@iterable.com',
              userId: '1234',
              firstName: 'John',
              lastName: 'Smith',
              someDate: '2016-11-29 13:22:56',
              isFoobar: 'true',
            },
            {
              id: 'ExampleUser2',
              email: 'jane@iterable.com',
              userId: 'user5678',
              firstName: 'Jane',
              lastName: 'Smith',
              someDate: '2015-11-13',
              isFoobar: 'false',
            },
          ]}
          selectedRows={[]}
        />
      </Table>
    </div>
  );
};
